<template>
    <div>
        <form id="form-set-item-colaborador" class="ajax_off" @submit.prevent="submit()">
            <b-form-group id="input-group-1" label="Colaborador" label-for="input-1">
                <e-select :custom_option="{ text: 'TODOS', value: null }" name="responsavel_id"
                    v-model.number="item_status.colaborador_id" route="colaboradores" />
            </b-form-group>
            <div class="row">

                <b-form-group class="col-6" id="input-group-2" label="Data de Inicio" label-for="input-2">
                    <date-picker name="inicio" id="inicio" placeholder="Selecione a data de início" value-type="YYYY-MM-DD"
                        format="DD-MM-YYYY" v-model="item_status.inicio" type="date" @change="setDays"></date-picker>
                </b-form-group>

                <b-form-group class="col-6" id="input-group-3" label="Data de Termino" label-for="input-3">
                    <date-picker name="fim" id="fim" placeholder="Selecione a data de termino" value-type="YYYY-MM-DD"
                        format="DD-MM-YYYY" v-model="item_status.fim" type="date" @change="setDays"></date-picker>


                </b-form-group>
            </div>
            <b-form-group id="input-group-4" label="Dias" description="Total de dias para ser realizado"
                label-for="input-4">
                <b-form-input v-model="item_status.dias" type="number" @input="calculateDates"></b-form-input>
            </b-form-group>
        </form>
    </div>
</template>


<script>
export default {
    props: {
        status: null,
        tarefa_checklist_item_id: Number
    },
    data() {
        return {
            error: false,
            item_status: {
                id: null,
                tarefa_checklist_item_id: this.tarefa_checklist_item_id,
                colaborador_id: null,
                inicio: null,
                fim: null,
                dias: null
            }
        }
    },
    watch: {
        "item_status.inicio"(newVal, oldVal) {
            if (newVal == '' || newVal == null)
                this.item_status.dias = null
        },
        "item_status.fim"(newVal, oldVal) {
            if (newVal == '' || newVal == null)
                this.item_status.dias = null
        }
    },
    created() {
        if(this.status)
            this.item_status = this.status;
    },
    methods: {
        setDays() {
            if (this.item_status.inicio && this.item_status.fim) {
                const startDateObj = new Date(this.item_status.inicio);
                const endDateObj = new Date(this.item_status.fim);

                if (startDateObj > endDateObj) {
                    this.error = true;
                    this.item_status.dias = null;
                } else {
                    this.error = false;
                    const timeDifference = endDateObj - startDateObj;
                    const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                    this.item_status.dias = dayDifference;
                }
            }
        },
        calculateDates() {
            if (this.item_status.dias !== null) {

                const dias = Number(this.item_status.dias);

                if (dias <= 0) {
                    this.error = true;
                    this.item_status.inicio = null;
                    this.item_status.fim = null;
                } else {
                    this.item_status.inicio = null;
                    this.item_status.fim = null;

                    this.error = false;

                    const today = new Date();
                    const startDate = new Date(today);
                    startDate.setDate(startDate.getDate() + 1);

                    const endDate = new Date(startDate);
                    endDate.setDate(endDate.getDate() + (dias - 1));

                    this.item_status.inicio = startDate.toISOString().split("T")[0];
                    this.item_status.fim = endDate.toISOString().split("T")[0];
                }
            }
        },

        async submit() {
            if (this.item_status.id) {
                await this.$api.put(`tarefa-checklist-item-status/${this.item_status.id}`, this.item_status)
            } else {
                await this.$api.post(`tarefa-checklist-item-status`, this.item_status)
            }
            this.$emit('onSubmit');
            this.$bvModal.hide(`modal-checklist-item-colaborador-${this.tarefa_checklist_item_id}`);
        }
    }

}

</script>
